import { render } from "./discovery.vue?vue&type=template&id=c1fcd142&scoped=true"
import script from "./discovery.vue?vue&type=script&lang=js"
export * from "./discovery.vue?vue&type=script&lang=js"

import "./discovery.vue?vue&type=style&index=0&id=c1fcd142&lang=less&scoped=true"

import exportComponent from "D:\\myWorkspace\\CoreServiceAzure\\CoreServiceCloud\\MyNews\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1fcd142"]])

export default __exports__